export const uaLimitedReleaseDetailConstants = {
  UA_LIMITED_RELEASE_DETAIL_LOADING: "UA_LIMITED_RELEASE_DETAIL_LOADING",
  UA_LIMITED_RELEASE_DETAIL_SUCCESS: "UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  UA_LIMITED_RELEASE_DETAIL_FAILURE: "UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createUALimitedReleaseDetailConstants = {
  CREATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_UA_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editUALimitedReleaseDetailConstants = {
  EDIT_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_UA_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteUALimitedReleaseDetailConstants = {
  DELETE_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_UA_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const addTargetUALimitedReleaseDetailConstants = {
  ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING",
  ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "ADD_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const removeTargetUALimitedReleaseDetailConstants = {
  REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_LOADING",
  REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "REMOVE_TARGET_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateUALimitedReleaseDetailConstants = {
  ACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateUALimitedReleaseDetailConstants = {
  DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_UA_LIMITED_RELEASE_DETAIL_FAILURE",
};
